import React from "react";

const SvgFb = (props) => (
  <svg viewBox="0 0 16 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8283 5.50445C12.417 5.50445 15.4458 5.50445 15.4458 5.50445V0.0197913L10.4629 0C4.92894 0 3.67132 4.09432 3.67132 6.70676V10.3632H0.472168V16.0111H3.67132C3.67132 23.2646 3.67132 32 3.67132 32H10.4003C10.4003 32 10.4003 23.1805 10.4003 16.0111H14.9423L15.531 10.3632H10.4003V7.04322C10.4003 5.79637 11.2396 5.50445 11.8283 5.50445Z"
      fill="#0000FF"
    />
  </svg>
);

export default SvgFb;
